import { combineComponents } from "~utils";

import { BoardImageProvider } from "./board-image-provider";
import { ShareFormationUrlProvider } from "./share-formation-url";

export const UiProvider = combineComponents(
  BoardImageProvider,
  ShareFormationUrlProvider,
);
